import {
  ApplicationInsights,
  SeverityLevel,
} from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import type { detect } from "detect-browser";
import { TelemetryUser } from "./telemetryUser";
const browserHistory = createBrowserHistory();

class AppInsightsTelemetry {
  reactPlugin: ReactPlugin | null;
  appInsights: ApplicationInsights | null;
  isInit: boolean;

  constructor() {
    this.reactPlugin = null;
    this.appInsights = null;
    this.isInit = false;
  }

  init = () => {
    if (this.isInit) return;

    this.reactPlugin = new ReactPlugin();
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey:
          import.meta.env.INSIGHTS_INSTRUMENTATION_KEY,
        maxBatchInterval: 0,
        disableFetchTracking: false,
        disableAjaxTracking: false,
        disableExceptionTracking: false,
        extensions: [this.reactPlugin],
        extensionConfig: {
          [this.reactPlugin.identifier]: {
            history: browserHistory,
          },
        },
      },
    });
    this.appInsights.loadAppInsights();
    this.isInit = true;
  };

  trackException = (
    uuid: string,
    errorMessage: unknown,
    browserType: ReturnType<typeof detect>,
    user: TelemetryUser | null,
    router: unknown
  ) => {
    const error = {
      uuid: uuid,
      errorMessage: JSON.stringify(errorMessage),
      browser: browserType,
      profile: user,
      router: router ? router : null,
    };
    const aiError = JSON.stringify(error);
    this.appInsights?.trackException({
      error: new Error(aiError),
      severityLevel: SeverityLevel.Error,
      id: "Client Error",
    });
  };

  // We're not currently tying identifying user info with our App Insights data
  beginUser = (_user: TelemetryUser) => {};
  endUser = () => {};
}

export const appInsightsTelemetry = import.meta.env
  .INSIGHTS_TELEMETRY_ENABLED
  ? new AppInsightsTelemetry()
  : null;
